import React from "react";
import SolCard from "./SolCard";

const SolutionsSec = () => {
  const services = [
    {
      img: "/sol1.png",
      title: "Broadcast & Media",
      list: ["TV Studio", "Film Camera", "Content Production"],
      link: "/our-solutions/broadcast",
      linkText: "Read More",
    },
    {
      img: "/sol2.png",
      title: "Sports & Live Events",
      list: ["Packed Stadium", "Live Event Camera Ops"],
      link: "/our-solutions/sports",
      linkText: "Read More",
    },
    {
      img: "/sol3.png",
      title: "Telecom & ISPs",
      list: ["Fiber Cables", "Mobile Tower"],
      link: "/our-solutions/telecom",
      linkText: "Read More",
    },
    {
      img: "/sol4.png",
      title: "Maritime & Aviation",
      list: ["Banking Office", "Energy", "Mining Site With Satellite Dish"],
      link: "/our-solutions/maritime",
      linkText: "Read More",
    },
    {
      img: "/sol5.png",
      title: "Government & Defence",
      list: ["Ship Deck With VSAT Dome", "Airplane Cabin w/Full Logo"],
      link: "/our-solutions/government",
      linkText: "Read More",
    },
    {
      img: "/sol6.png",
      title: "Enterprise & Corporate",
      list: ["Government Command Center", "Secure Comm Room"],
      link: "/our-solutions/enterprise",
      linkText: "Read More",
    },
  ];
  return (
    <section className="services-sec mt-5">
      <img src="/srv-bg.png" alt="heading-img" className="heading-img" />
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="heading-wrapper">
              <h2 className="sec-head white">Our Solutions</h2>
              <p className="para white">
                At Video Vision Media, we deliver solutions tailored to the
                industries we serve. From live sports to government
                communications, our expertise ensures content and connectivity
                are always reliable, always secure, and always ready for global
                audiences.
              </p>
            </div>
          </div>
        </div>
        <div className="row row-gap-25 mt-4">
          {services.map((service, index) => (
            <div className="col-lg-4 col-12" key={index}>
              <SolCard data={service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSec;
